import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "modal-active-integration__content"
};
const _hoisted_2 = { class: "modal-active-integration__header" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { class: "modal-active-integration__title" };
const _hoisted_5 = { class: "modal-active-integration__actions customScrollBar" };
const _hoisted_6 = { class: "modal-active-integration__group" };
const _hoisted_7 = { for: "select-instance" };
const _hoisted_8 = ["value"];
const _hoisted_9 = ["for"];
const _hoisted_10 = ["onUpdate:modelValue"];
const _hoisted_11 = ["value"];
const _hoisted_12 = ["onUpdate:modelValue", "type"];
const _hoisted_13 = { class: "modal-active-integration__submit" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
    key: 1,
    class: "modal-active-integration__error"
};
const _hoisted_16 = { class: "error-message" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("div", { class: "error-message__icon" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-error-60px" })
], -1);
const _hoisted_18 = { class: "error-message__message" };
const _hoisted_19 = { class: "error-message__button" };
const _hoisted_20 = ["onClick"];
import BaseLoaderSpinner from '@/components/_atoms/BaseLoaderSpinner.vue';
import { fetchColumnsList, fetchConfigConnectors } from '@/features/AudienceManager/data';
import { getConnectorIcon } from '@/features/AudienceManager/utils';
import i18n from '@/i18n';
import { valueType } from '@/utilities/constants';
import { isEmpty } from 'lodash';
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import SectionTemplateFields from './TemplateFields.vue';
const OMNICHAT_ALIAS = 'omnichat';
const ALLIN_ALIAS = 'allin';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Modal',
    props: {
        data: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const route = useRoute();
        const isLoading = ref(false);
        const hasNoConnectorConfiguration = ref(false);
        const connectorFieldsTemplate = ref([]);
        const connectorData = ref(props.data.connector);
        const connectorName = ref(null);
        const templateColumnsOptions = ref([]);
        const configInstances = ref([]);
        const selectedInstanceId = ref(0);
        const isSelectType = (type) => type === 'select';
        const buildTemplateFieldsConfig = (config) => ({
            templateId: config?.templateId ?? '',
            fields: { ...(config?.fields ?? {}) },
        });
        const dynamicFieldTemplateConfig = ref(buildTemplateFieldsConfig());
        const applyDynamicTemplateConfig = (config) => {
            dynamicFieldTemplateConfig.value = buildTemplateFieldsConfig(config);
        };
        const audienceActiveConnectors = computed(() => store.getters['audienceManager/audienceActiveConnectors']);
        const isCreateMode = computed(() => route.path.split('/').includes('create'));
        const isOmnichatConnector = computed(() => connectorData.value?.alias === OMNICHAT_ALIAS);
        const getFieldOptions = (field) => {
            return isSelectType(field.type) && 'options' in field ? field.options : [];
        };
        const initialTemplateFieldsConfig = computed(() => {
            // Do not initialize template fields configuration in create mode,
            // because there is no existing connector configuration to prefill fields.
            if (!isOmnichatConnector.value || isCreateMode.value)
                return null;
            const omnichatConnector = audienceActiveConnectors.value.find(connector => connector.alias === OMNICHAT_ALIAS);
            if (!omnichatConnector || !Array.isArray(omnichatConnector.config) || !omnichatConnector.config.length) {
                return null;
            }
            const configData = omnichatConnector.config[0];
            return buildTemplateFieldsConfig({
                templateId: configData?.templateId,
                fields: configData?.fields,
            });
        });
        watch(() => initialTemplateFieldsConfig.value, newConfig => {
            applyDynamicTemplateConfig(newConfig);
            if (newConfig && connectorFieldsTemplate.value.length) {
                nextTick(() => {
                    populateOmnichatFieldsFromConfig();
                });
            }
        }, { immediate: true });
        const activeConnectorModalVisible = computed({
            get: () => store.state.audienceManager.activeConnectorModal.isVisible,
            set: value => {
                store.commit('audienceManager/TOGGLE_ACTIVATE_INTEGRATION_MODAL', {
                    isVisible: value,
                    connector: {},
                    instanceId: undefined,
                });
            },
        });
        const updateDynamicTemplateFields = configs => {
            applyDynamicTemplateConfig(configs);
        };
        const modalTitle = computed(() => {
            return connectorData.value?.enabled
                ? i18n.global.t('integrations.edit-integration')
                : i18n.global.t('audiences.integration.enable');
        });
        function populateOmnichatFieldsFromConfig() {
            const omnichatConnector = audienceActiveConnectors.value.find(connector => connector.alias === OMNICHAT_ALIAS);
            const configData = initialTemplateFieldsConfig.value;
            if (!omnichatConnector || !configData)
                return;
            connectorFieldsTemplate.value = connectorFieldsTemplate.value.map(field => {
                if (field.name === 'templateId' && configData.templateId) {
                    return { ...field, defaultOption: configData.templateId };
                }
                if (field.name === 'type_send_campaign' && omnichatConnector.typeSendCampaign) {
                    return { ...field, defaultOption: omnichatConnector.typeSendCampaign };
                }
                return field;
            });
            applyDynamicTemplateConfig(configData);
        }
        function populateAllinFieldsFromConfig() {
            if (isCreateMode.value)
                return;
            const allInConnector = audienceActiveConnectors.value.find(connector => connector.alias === ALLIN_ALIAS);
            if (!allInConnector?.config)
                return;
            const configArray = Array.isArray(allInConnector.config) ? allInConnector.config : [];
            const customAudience = configArray.find(item => item?.customAudience)?.customAudience || '';
            const caName = configArray.find(item => item?.caName)?.caName || '';
            const fieldMappings = {
                customAudience,
                caName,
            };
            connectorFieldsTemplate.value = connectorFieldsTemplate.value.map(field => {
                return Object.hasOwn(fieldMappings, field.name) ? { ...field, defaultOption: fieldMappings[field.name] } : field;
            });
        }
        const fetchConnectorConfiguration = (event) => {
            isLoading.value = true;
            const isInstanceChange = event?.type === 'change';
            const connectorAlias = connectorData.value?.alias || props.data.connector.alias;
            const isOmnichat = connectorAlias === OMNICHAT_ALIAS;
            const isAllIn = connectorAlias === ALLIN_ALIAS;
            if (!isInstanceChange) {
                hasNoConnectorConfiguration.value = false;
                configInstances.value = [];
            }
            const params = {
                connector: connectorAlias,
                enabled: false,
                instanceId: isInstanceChange ? selectedInstanceId.value : null,
            };
            connectorFieldsTemplate.value = [];
            fetchConfigConnectors(params)
                .then(data => {
                if (!data.hasConfig || !data.success || !data?.instances?.length) {
                    hasNoConnectorConfiguration.value = true;
                    return;
                }
                if (!isInstanceChange) {
                    configInstances.value = data.instances;
                    selectedInstanceId.value = configInstances.value[0]?.id || 0;
                }
                const hasAudienceFields = typeof data?.audience !== valueType.string && !isEmpty(data?.audience);
                if (hasAudienceFields) {
                    connectorFieldsTemplate.value = data.audience;
                }
                if (isOmnichat) {
                    connectorFieldsTemplate.value = [...connectorFieldsTemplate.value].reverse();
                    populateOmnichatFieldsFromConfig();
                }
                if (isAllIn) {
                    populateAllinFieldsFromConfig();
                }
            })
                .finally(() => {
                isLoading.value = false;
                if (isOmnichat) {
                    fetchColumnsListIntegrations();
                }
            });
        };
        const fetchColumnsListIntegrations = () => {
            fetchColumnsList().then(data => {
                templateColumnsOptions.value = data.columns;
            });
        };
        const templateFieldConfig = computed(() => {
            return connectorFieldsTemplate.value.find(element => element.name === 'templateId') || null;
        });
        const submitIntegration = () => {
            const formattedConfig = templateFieldConfig.value
                ? JSON.stringify([dynamicFieldTemplateConfig.value])
                : JSON.stringify(connectorFieldsTemplate.value.map(field => ({ [field.name]: field.defaultOption })));
            if (isOmnichatConnector.value) {
                const typeSendCampaignField = connectorFieldsTemplate.value.find(field => field.name === 'type_send_campaign');
                const isOmnichatAndIndividualApproach = typeSendCampaignField?.defaultOption === '0';
                store.commit('audienceManager/UPDATE_IS_OMNICHAT_AND_INDIVIDUAL_APPROACH', isOmnichatAndIndividualApproach);
            }
            store.dispatch('audienceManager/updateIntegration', {
                connect: connectorData.value?.alias,
                alias: connectorData.value?.alias,
                enabled: true,
                interval: connectorData.value?.interval,
                instance: selectedInstanceId.value,
                config: formattedConfig,
                editable: true,
                startDatetime: '',
            });
            closeModal();
        };
        const closeModal = () => {
            activeConnectorModalVisible.value = false;
        };
        onMounted(() => {
            connectorData.value = props.data.connector;
            connectorName.value = props.data.connector?.name;
            fetchConnectorConfiguration();
        });
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: activeConnectorModalVisible.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((activeConnectorModalVisible).value = $event)),
                class: "modal-active-integration"
            }, {
                default: _withCtx(() => [
                    (!isLoading.value && !hasNoConnectorConfiguration.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("img", {
                                    src: _unref(getConnectorIcon)(connectorData.value.alias),
                                    alt: connectorName.value
                                }, null, 8, _hoisted_3),
                                _createElementVNode("h2", _hoisted_4, _toDisplayString(modalTitle.value), 1)
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$tc('settings.integrations.configuration')), 1),
                                    _withDirectives(_createElementVNode("select", {
                                        id: "select-instance",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedInstanceId).value = $event)),
                                        onChange: fetchConnectorConfiguration
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configInstances.value, (instance) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: instance.id,
                                                value: instance.id
                                            }, _toDisplayString(instance.name), 9, _hoisted_8));
                                        }), 128))
                                    ], 544), [
                                        [_vModelSelect, selectedInstanceId.value]
                                    ])
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connectorFieldsTemplate.value, (field, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "modal-active-integration__group"
                                    }, [
                                        _createElementVNode("label", {
                                            for: field.name
                                        }, _toDisplayString(field.label), 9, _hoisted_9),
                                        (isSelectType(field.type))
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: _normalizeClass([
                                                    'modal-active-integration__wrap',
                                                    { 'modal-active-integration__template-box': field.name === 'templateId' },
                                                ])
                                            }, [
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": ($event) => ((field.defaultOption) = $event)
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFieldOptions(field), (optionTemplate) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: optionTemplate.id,
                                                            value: optionTemplate.id
                                                        }, _toDisplayString(optionTemplate.name), 9, _hoisted_11));
                                                    }), 128))
                                                ], 8, _hoisted_10), [
                                                    [_vModelSelect, field.defaultOption]
                                                ])
                                            ], 2))
                                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                key: 1,
                                                "onUpdate:modelValue": ($event) => ((field.defaultOption) = $event),
                                                type: field.type,
                                                class: _normalizeClass({ error: field.error })
                                            }, null, 10, _hoisted_12)), [
                                                [_vModelDynamic, field.defaultOption]
                                            ]),
                                        (field.name === 'templateId')
                                            ? (_openBlock(), _createBlock(SectionTemplateFields, {
                                                key: 2,
                                                "connector-fields": connectorFieldsTemplate.value,
                                                "column-options": templateColumnsOptions.value,
                                                "initial-config": initialTemplateFieldsConfig.value,
                                                "onUpdate:fieldValues": updateDynamicTemplateFields
                                            }, null, 8, ["connector-fields", "column-options", "initial-config"]))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("button", {
                                    class: "btn modal-active-integration__btn",
                                    onClick: _withModifiers(submitIntegration, ["prevent"])
                                }, _toDisplayString(connectorData.value?.enabled
                                    ? _ctx.$t('settings.integrations.edit-integration')
                                    : _ctx.$t('settings.integrations.active-integration')), 9, _hoisted_14)
                            ])
                        ]))
                        : (hasNoConnectorConfiguration.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                    _hoisted_17,
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('settings.integrations.messages.hasnt-config')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("button", {
                                            class: "btn btn-continue",
                                            onClick: _withModifiers(closeModal, ["prevent"])
                                        }, _toDisplayString(_ctx.$t('confirm')), 9, _hoisted_20)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true),
                    (isLoading.value)
                        ? (_openBlock(), _createBlock(BaseLoaderSpinner, { key: 2 }))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
